<template>
  <b-modal
    ref="modal"
    id="modal-venda-cadastro-nota-fiscal"
    hide-header
    hide-footer
    body-class="p-0 overflow-hidden"
    content-class="border-0 shadow-lg"
    size="xl"
  >
    <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #20a8d8 0%, #000000 100%) !important;">
      <div class="header-icon-wrapper mr-3 bg-white-10">
        <i class="fa fa-file-text-o text-primary"></i>
      </div>
      <div>
        <h5 class="mb-0 font-weight-bold text-white">Emissao de Nota Fiscal Eletronica</h5>
        <small class="text-white opacity-75">Configuracao e transmissao de documentos fiscais</small>
      </div>
      <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="fechar()">
        <i class="fa fa-times fa-lg"></i>
      </b-button>
    </div>

    <div class="p-4 bg-white">
      <div class="modal-info-bar mb-4 bg-light border shadow-sm p-3 rounded">
        <b-row align-v="center">
          <b-col md="6">
            <small class="modal-label-premium">Cliente Destinatario</small>
            <h5 class="mb-0 font-weight-bold text-dark">{{ dados.nomeCliente }}</h5>
          </b-col>
          <b-col md="3" class="border-left">
            <small class="modal-label-premium">Documento Base</small>
            <h5 class="mb-0 font-weight-bold text-primary">{{ dados.documento }}</h5>
          </b-col>
          <b-col md="3" class="border-left text-right">
            <small class="modal-label-premium">Valor da Nota</small>
            <h5 class="mb-0 font-weight-bold text-success">{{ dados.total }}</h5>
          </b-col>
        </b-row>
      </div>

      <div class="modal-section-title mb-3">
        <i class="fa fa-cogs mr-2 text-primary"></i> Parametros Fiscais de Emissao
      </div>

      <div class="p-4 bg-light rounded border shadow-xs mb-4">
        <b-row class="mb-3">
          <b-col :md="nfeMotorNodeAtivo ? 8 : 12">
            <label class="modal-label-premium">Empresa Emitente</label>
            <b-form-select
              v-model="dados.empresaId"
              :options="empresas.options"
              :state="valEmpresaId"
              class="rounded-pill shadow-xs"
            />
          </b-col>
          <b-col v-if="nfeMotorNodeAtivo" md="4">
            <label class="modal-label-premium">Tipo de Atendimento</label>
            <b-form-select
              v-model="dados.opTipoAtendimento"
              :options="opTipoAtendimentoNfeOptions"
              :state="valTipoAtendimentoNfe"
              class="rounded-pill shadow-xs"
            />
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col md="2">
            <label class="modal-label-premium">Data Sai/Ent</label>
            <CecInputData v-model="dados.DT_SADIA_ENTRADA" input-class="rounded-pill shadow-xs" />
          </b-col>
          <b-col md="2">
            <label class="modal-label-premium">Hora Sai/Ent</label>
            <b-form-timepicker
              v-model="dados.TX_HORA_ENTRA_SAI"
              locale="pt-BR"
              placeholder="00:00:00"
              show-seconds
              class="rounded-pill shadow-xs"
            />
          </b-col>
          <b-col v-if="nfeMotorNodeAtivo" md="8">
            <label class="modal-label-premium">Tipo de Movimentacao</label>
            <b-form-select
              v-model="dados.tipoMovimentacaoId"
              :options="dados.tipoMovimentacoes.options"
              :state="valTipoMovimentacaoId"
              class="rounded-pill shadow-xs"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <label class="modal-label-premium">Informacoes Complementares (Contribuinte)</label>
            <b-form-textarea
              v-model="dados.obsContribuinte"
              placeholder="Informacoes que sairao no corpo da nota..."
              rows="3"
              class="rounded shadow-xs border-0"
            />
          </b-col>
        </b-row>
      </div>

      <b-alert
        v-if="cfopDiagnostico"
        :variant="cfopDiagnostico.variant"
        show
        class="mb-4 rounded"
      >
        <strong>CFOP {{ cfopDiagnostico.id }}</strong> - {{ cfopDiagnostico.mensagem }}
      </b-alert>

      <b-alert
        v-if="preflightPendencias.length"
        :variant="preflightTemErro ? 'danger' : 'warning'"
        show
        class="mb-4 rounded"
      >
        <div class="font-weight-bold mb-2">
          Validacao fiscal da NF-e
          <span v-if="dados.nfeId" class="ml-2 text-muted">#{{ dados.nfeId }}</span>
        </div>
        <ul class="mb-0 pl-3">
          <li v-for="(pendencia, index) in preflightPendencias" :key="index">
            <strong>{{ pendencia.codigo }}</strong> - {{ pendencia.mensagem }}
          </li>
        </ul>
      </b-alert>

      <div class="modal-section-title mb-3">
        <i class="fa fa-list-alt mr-2 text-primary"></i> Conferencia de Itens
      </div>
      <div class="bg-white rounded border shadow-xs overflow-hidden">
        <b-table
          hover
          show-empty
          empty-text="Nenhum item para faturar"
          small
          responsive
          class="mb-0 table-finance"
          :items="tabelaItens.items"
          :fields="tabelaItens.fields"
        />
      </div>

      <b-alert
        v-if="dados.mensagem.texto"
        :variant="dados.mensagem.tipo"
        show
        class="mt-3 mb-0 rounded"
      >
        <i class="fa mr-2" :class="dados.mensagem.tipo === 'danger' ? 'fa-times-circle' : (dados.mensagem.tipo === 'success' ? 'fa-check-circle' : 'fa-exclamation-triangle')"></i>
        {{ dados.mensagem.texto }}
      </b-alert>
    </div>

    <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-between">
      <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="fechar()">
        CANCELAR
      </b-button>
      <div class="d-flex flex-wrap justify-content-end">
        <b-button
          v-if="nfeMotorNodeAtivo"
          variant="outline-primary"
          pill
          class="px-4 mr-2 font-weight-bold shadow-sm"
          @click="validarNotaFiscalMotorNode()"
          :disabled="!valEmitirNotaFiscal"
        >
          <i class="fa fa-check-circle mr-1"></i> VALIDAR NFE
        </b-button>
        <b-button variant="primary" pill class="px-5 font-weight-bold shadow-sm" @click="emitirNotaFiscal()" :disabled="!valEmitirNotaFiscal">
          <i class="fa fa-send mr-1"></i> TRANSMITIR NFE
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import moment from 'moment'
import Tools from '@/tools/tools.js'
import CecInputData from '@/components/Cec/CecInputData.vue'

function formatarDataBrSemFuso(value) {
  if (!value) return null
  const texto = String(value).trim()
  const matchIso = texto.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (matchIso) {
    const [, ano, mes, dia] = matchIso
    return `${dia}/${mes}/${ano}`
  }
  const dataUtc = moment.utc(texto, moment.ISO_8601, true)
  if (dataUtc.isValid()) return dataUtc.format('DD/MM/YYYY')
  const dataLocal = moment(texto)
  return dataLocal.isValid() ? dataLocal.format('DD/MM/YYYY') : null
}

function criarDadosNotaFiscal() {
  return {
    venda: null,
    id: null,
    SITUACAO: null,
    documento: null,
    dataVenda: null,
    nomeCliente: null,
    nomeVendedor: null,
    empresaId: null,
    DT_SADIA_ENTRADA: null,
    TX_HORA_ENTRA_SAI: null,
    cliente: null,
    tipoMovimentacaoId: null,
    cfopId: null,
    consumidor: null,
    textoId: null,
    obsContribuinte: null,
    obsOutros: null,
    opTipoAtendimento: null,
    nfeId: null,
    preflight: null,
    diagnostico: null,
    cfopResolucao: null,
    validacaoIntegrador: null,
    total: 'R$ 0,00',
    naturezaTexto: '',
    tipoMovimentacoes: { selected: null, options: [], items: [] },
    cfops: { selected: null, options: [], items: [] },
    textos: { selected: null, options: [], items: [] },
    mensagem: { texto: null, tipo: null }
  }
}

export default {
  props: {
    forcarMotorNode: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CecInputData
  },
  data() {
    return {
      empresas: {
        items: [],
        options: [{ value: null, text: '' }]
      },
      opTipoAtendimentoNfeOptions: [
        { value: null, text: 'Selecione...' },
        { value: '1', text: '1 - Operacao presencial' },
        { value: '2', text: '2 - Nao presencial, internet' },
        { value: '3', text: '3 - Nao presencial, teleatendimento' },
        { value: '9', text: '9 - Nao presencial, outros' },
        { value: '0', text: '0 - Nao se aplica' }
      ],
      dados: criarDadosNotaFiscal(),
      tabelaItens: {
        items: [],
        fields: [
          { key: 'COD_PRO', class: 'text-right', label: 'Codigo' },
          { key: 'TX_NOME_PRODUTO', label: 'Produto' },
          {
            key: 'QUANT',
            class: 'text-right',
            label: 'Quantidade',
            formatter: value => value ? value.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 3 }) : '0,000'
          },
          { key: 'PECAS', class: 'text-right', label: 'Pecas' },
          {
            key: 'VL_UNT',
            class: 'text-right',
            label: 'Valor',
            formatter: value => value ? value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : 'R$ 0,00'
          },
          {
            key: 'VL_TOTAL_BRUTO',
            class: 'text-right',
            label: 'Total',
            formatter: value => value ? value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : 'R$ 0,00'
          }
        ]
      }
    }
  },
  computed: {
    nfeMotorNodeAtivo() {
      if (this.forcarMotorNode) return true
      const flag = window.localStorage.getItem('NFE_MOTOR_NODE_ENABLED')
      return ['1', 'S', 'SIM', 'TRUE'].includes(String(flag || '').trim().toUpperCase())
    },
    preflightPendencias() {
      return this.dados.preflight?.pendencias || []
    },
    preflightTemErro() {
      return this.preflightPendencias.some(item => item.nivel === 'ERRO')
    },
    cfopDiagnostico() {
      const resolucao = this.dados.cfopResolucao || this.dados.diagnostico?.cfop || null
      if (!resolucao) return null

      const id = resolucao.cfopId || resolucao.id || resolucao.cfop?.CONTADOR || this.dados.diagnostico?.cfop?.id
      const origem = String(resolucao.origem || '').trim()
      if (!id || !origem) return null

      const veioDaMatriz = origem === 'NFE_CFOP_REGRA'
      return {
        id,
        variant: veioDaMatriz ? 'info' : 'warning',
        mensagem: veioDaMatriz
          ? 'definido pela matriz fiscal NFE_CFOP_REGRA.'
          : 'definido pelo CFOP padrao do tipo de movimentacao.'
      }
    },
    valEmitirNotaFiscal() {
      return this.isVendaFechada(this.dados) &&
        this.valEmpresaId &&
        this.valTipoMovimentacaoId &&
        (this.nfeMotorNodeAtivo || this.valCfopId) &&
        (this.nfeMotorNodeAtivo || this.valConsumidor) &&
        this.valTipoAtendimentoNfe
    },
    valEmpresaId() {
      return this.dados.empresaId ? true : false
    },
    valTipoMovimentacaoId() {
      return this.dados.tipoMovimentacaoId ? true : false
    },
    valCfopId() {
      return this.dados.cfopId ? true : false
    },
    valConsumidor() {
      return this.dados.consumidor ? true : false
    },
    valTipoAtendimentoNfe() {
      if (!this.nfeMotorNodeAtivo) return true
      return ['0', '1', '2', '3', '9'].includes(String(this.dados.opTipoAtendimento || '').trim())
    }
  },
  watch: {
    'dados.tipoMovimentacaoId': function (val) {
      if (!val) return
      const tipoMov = this.dados.tipoMovimentacoes.items.find(item => Number(item.ID) === Number(val))
      if (!tipoMov) return
      this.dados.cfopId = tipoMov.CFOP_ID
      this.dados.textoId = tipoMov.TEXTO_NFE_ID
      this.dados.naturezaTexto = tipoMov.DESCRICAO
      this.dados.obsContribuinte = this.montarObservacaoContribuinte()
    }
  },
  methods: {
    isVendaFechada(item) {
      return String((item && item.SITUACAO) || '').trim() === '1'
    },
    statusNotaFiscal(item) {
      const statusReal = String(item && item.NFE_OP_STATUS != null ? item.NFE_OP_STATUS : '').trim()
      if (statusReal) return statusReal
      return String(item && item.OP_STATUS_NOTA_FISCAL_EMITIDA != null ? item.OP_STATUS_NOTA_FISCAL_EMITIDA : '').trim()
    },
    podeGerarNotaFiscal(item) {
      const statusNfe = this.statusNotaFiscal(item)
      return this.isVendaFechada(item) && statusNfe !== '2'
    },
    async abrir(item) {
      if (!this.podeGerarNotaFiscal(item)) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Nota fiscal permitida apenas para venda fechada.')
        return
      }

      try {
        this.$store.commit('controle/setAguardando', true)
        this.$store.commit('venda/SET_REGISTRO_SELECIONADO_ID', item.SEQUENCIA)
        this.dados = criarDadosNotaFiscal()
        this.tabelaItens.items = []

        await this.carregarTipoMovimentacoes()
        await this.carregarCFOP()
        await this.carregarEmpresas()
        await this.carregarTextos()
        await this.carregarCliente(item.COD_CLI)
        await this.carregarBoletoInfo(item.SEQUENCIA)

        this.dados.id = item.SEQUENCIA
        this.dados.SITUACAO = item.SITUACAO
        this.dados.documento = item.N_VENDA
        this.dados.dataVenda = formatarDataBrSemFuso(item.DT_SAIDA) || ''
        this.dados.DT_SADIA_ENTRADA = moment().format('YYYY-MM-DD')
        this.dados.TX_HORA_ENTRA_SAI = moment().format('HH:mm:ss')
        this.dados.nomeCliente = item.NOME_CLIENTE
        this.dados.nomeVendedor = item.NOME_VENDEDOR
        this.dados.total = this.formatCurrency(item.VL_TOTAL_NFE)

        const tipoMovimentacao = this.dados.tipoMovimentacoes.items.find(tipos => Number(tipos.ID) === Number(item.TIPO_MOVIMENTACAO_ID))
        this.dados.tipoMovimentacaoId = tipoMovimentacao?.ID || item.TIPO_MOVIMENTACAO_ID || null
        this.dados.cfopId = tipoMovimentacao?.CFOP_ID || null
        this.dados.consumidor = this.dados.cliente?.OP_CONSUMIDOR || null
        this.dados.naturezaTexto = tipoMovimentacao?.DESCRICAO || ''
        this.dados.obsContribuinte = this.montarObservacaoContribuinte()

        const response = await this.$http.get('/api/protected/venda/item/getListagemByVenda/' + item.SEQUENCIA)
        this.tabelaItens.items = response.data || []

        this.dados.mensagem = { texto: null, tipo: null }
        this.$refs.modal.show()
      } catch (err) {
        console.error(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operacao indisponivel')
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    fechar() {
      this.$refs.modal.hide()
    },
    async emitirNotaFiscal() {
      this.limparResultadoValidacao()

      if (!this.isVendaFechada(this.dados)) {
        this.dados.mensagem = { texto: 'Nota fiscal permitida apenas para venda fechada.', tipo: 'warning' }
        return
      }

      if (!this.valEmitirNotaFiscal) {
        this.dados.mensagem = { texto: 'Preencha os campos obrigatorios', tipo: 'warning' }
        return
      }

      if (this.nfeMotorNodeAtivo) {
        return this.emitirNotaFiscalMotorNode()
      }

      return this.emitirNotaFiscalLegado()
    },
    limparResultadoValidacao() {
      this.dados.mensagem = { texto: null, tipo: null }
      this.dados.preflight = null
      this.dados.diagnostico = null
      this.dados.cfopResolucao = null
      this.dados.validacaoIntegrador = null
      this.dados.nfeId = null
    },
    montarPayloadNotaFiscalBase() {
      return {
        vendaId: this.dados.id,
        empresaId: this.dados.empresaId,
        DT_SADIA_ENTRADA: this.dados.DT_SADIA_ENTRADA,
        DT_SAIDA_ENTRADA: this.dados.DT_SADIA_ENTRADA,
        TX_HORA_ENTRA_SAI: this.dados.TX_HORA_ENTRA_SAI,
        textoContribuinte: this.dados.obsContribuinte,
        textoContribuinteCompleto: true,
        usuario: window.localStorage.getItem('login'),
        tela: 'V'
      }
    },
    montarPayloadNotaFiscalMotorNode() {
      return {
        ...this.montarPayloadNotaFiscalBase(),
        tipoMovimentacaoId: this.dados.tipoMovimentacaoId,
        opTipoAtendimento: this.dados.opTipoAtendimento,
        dataSaida: this.dados.DT_SADIA_ENTRADA,
        horaSaida: this.dados.TX_HORA_ENTRA_SAI
      }
    },
    async validarNotaFiscalMotorNode() {
      this.limparResultadoValidacao()

      if (!this.nfeMotorNodeAtivo) return
      if (!this.isVendaFechada(this.dados)) {
        this.dados.mensagem = { texto: 'Nota fiscal permitida apenas para venda fechada.', tipo: 'warning' }
        return
      }
      if (!this.valEmitirNotaFiscal) {
        this.dados.mensagem = { texto: 'Preencha os campos obrigatorios', tipo: 'warning' }
        return
      }

      try {
        this.$store.commit('controle/setAguardando', true)
        const response = await this.$http.post('/api/protected/nfeMotor/diagnosticarVenda', this.montarPayloadNotaFiscalMotorNode())
        const resultado = response.data || {}
        this.dados.preflight = resultado.preflight || null
        this.dados.diagnostico = resultado.diagnostico || null
        this.dados.cfopResolucao = resultado.cfopResolucao || null

        if (!resultado.sucesso) {
          this.dados.mensagem = { texto: resultado.erro || 'Nao foi possivel validar a NF-e.', tipo: 'danger' }
          return
        }

        if (resultado.preflight && resultado.preflight.ok === false) {
          this.dados.mensagem = {
            texto: 'Validacao fiscal encontrou pendencias. Corrija os dados antes de transmitir.',
            tipo: this.preflightTemErro ? 'danger' : 'warning'
          }
          return
        }

        this.dados.mensagem = {
          texto: 'Validacao fiscal concluida sem erros. A NF-e ainda nao foi gravada.',
          tipo: 'success'
        }
      } catch (err) {
        console.error('Erro na validacao fiscal pelo motor Node:', err)
        this.dados.mensagem = { texto: this.extrairErroNotaFiscal(err), tipo: 'danger' }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async emitirNotaFiscalLegado() {
      try {
        this.$store.commit('controle/setAguardando', true)
        const response = await this.$http.post('/api/protected/notaFiscal/gerarIntegrador/', this.montarPayloadNotaFiscalBase())
        await this.finalizarEmissaoNotaFiscal(response.data)
      } catch (err) {
        console.error('Erro na geracao da nota:', err)
        this.dados.mensagem = { texto: this.extrairErroNotaFiscal(err), tipo: 'danger' }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async emitirNotaFiscalMotorNode() {
      try {
        this.$store.commit('controle/setAguardando', true)
        const prepararResponse = await this.$http.post('/api/protected/nfeMotor/prepararVenda', this.montarPayloadNotaFiscalMotorNode())
        const preparacao = prepararResponse.data || {}
        this.dados.nfeId = preparacao.nfeId || null
        this.dados.preflight = preparacao.preflight || null
        this.dados.cfopResolucao = preparacao.cfopResolucao || null
        this.dados.validacaoIntegrador = null

        if (!preparacao.sucesso || !preparacao.nfeId) {
          this.dados.mensagem = { texto: preparacao.erro || 'Nao foi possivel preparar a NF-e.', tipo: 'danger' }
          return
        }

        if (preparacao.preflight && preparacao.preflight.ok === false) {
          this.dados.mensagem = {
            texto: `NF-e ${preparacao.nfeId} preparada com pendencias fiscais. Corrija as pendencias antes de transmitir.`,
            tipo: 'danger'
          }
          return
        }

        const validacaoIntegradorResponse = await this.$http.post('/api/protected/notaFiscal/validarIntegrador', {
          nfeId: preparacao.nfeId,
          ...this.montarPayloadNotaFiscalMotorNode()
        })
        const validacaoIntegrador = validacaoIntegradorResponse.data || {}
        this.dados.validacaoIntegrador = validacaoIntegrador

        if (!validacaoIntegrador.sucesso) {
          this.dados.mensagem = {
            texto: validacaoIntegrador.erro || 'NF-e preparada, mas reprovada na validacao tecnica do integrador.',
            tipo: 'danger'
          }
          return
        }

        const transmitirResponse = await this.$http.post('/api/protected/notaFiscal/processarIntegrador', {
          nfeId: preparacao.nfeId,
          ...this.montarPayloadNotaFiscalMotorNode()
        })
        await this.finalizarEmissaoNotaFiscal(transmitirResponse.data)
      } catch (err) {
        console.error('Erro na geracao da nota pelo motor Node:', err)
        this.dados.mensagem = { texto: this.extrairErroNotaFiscal(err), tipo: 'danger' }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async finalizarEmissaoNotaFiscal(resultado) {
      if (!resultado || !resultado.sucesso || !resultado.pdfBase64) {
        const erro = resultado?.erro || 'Nao foi possivel gerar o PDF.'
        this.dados.mensagem = { texto: erro, tipo: 'danger' }
        return
      }

      const byteCharacters = atob(resultado.pdfBase64)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      const blob = new Blob([byteArray], { type: 'application/pdf' })
      window.open(window.URL.createObjectURL(blob))

      await this.$store.dispatch('venda/GERAR_LISTA')
      this.$emit('atualizar')
      this.fechar()
      this.$root.$bvToast.toast('Nota Fiscal gerada com sucesso!', {
        title: 'Aviso',
        autoHideDelay: 2000,
        variant: 'success',
        appendToast: true
      })
    },
    extrairErroNotaFiscal(err) {
      return (typeof err?.response?.data === 'string' && err.response.data)
        || err?.response?.data?.erro
        || err?.response?.data?.message
        || err?.message
        || String(err)
    },
    formatCurrency(value) {
      if (value === null || value === undefined) return 'R$ 0,00'
      const numericValue = typeof value === 'string' ? parseFloat(value.replace(',', '.')) : value
      if (isNaN(numericValue)) return 'R$ 0,00'
      return numericValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    async carregarEmpresas() {
      this.empresas.items = []
      this.empresas.options = []
      const response = await this.$http.get(this.$http.defaults.baseURL.concat('api/protected/empresa/getTodas'))
      const empresasArray = [].concat(response?.data || [])
      for (let emp of empresasArray) {
        this.empresas.options.push({ value: emp.CODIGO, text: `${emp.APELIDO} - ${emp.IE} - ${emp.RAZAO}` })
      }
    },
    async carregarTipoMovimentacoes() {
      const response = await this.$http.get('/api/protected/tipoMovimentacao/listar')
      const dados = response.data || []
      this.dados.tipoMovimentacoes.items = dados
      this.dados.tipoMovimentacoes.options = []
      for (const tipo of dados) {
        this.dados.tipoMovimentacoes.options.push({
          value: tipo.ID,
          text: tipo.ID + ' - ' + tipo.DESCRICAO
        })
      }
    },
    async carregarCFOP() {
      const response = await this.$http.get('/api/protected/cfop/listarTodos')
      const dados = response.data || []
      this.dados.cfops.items = dados
      this.dados.cfops.options = []
      for (const tipo of dados) {
        this.dados.cfops.options.push({
          value: tipo.CONTADOR,
          text: tipo.CONTADOR + ' - ' + tipo.UTILIZACAO
        })
      }
    },
    async carregarTextos() {
      const response = await this.$http.get('/api/protected/parametro/getTextos')
      const dados = response.data || []
      this.dados.textos.items = dados
      this.dados.textos.options = []
      for (const tipo of dados) {
        this.dados.textos.options.push({
          value: tipo.ID || '',
          text: tipo.ID ? tipo.ID + ' - ' + tipo.DESCRICAO : ''
        })
      }
    },
    async carregarCliente(clienteId) {
      const response = await this.$http.get('/api/protected/cliente/getById/' + clienteId)
      this.dados.cliente = response.data?.[0]
      return true
    },
    async carregarBoletoInfo(vendaId) {
      this.dados.obsOutros = null
      try {
        const boletoResult = await this.$http.get('/api/protected/areceber/getInfoBoletoByVendaId/' + vendaId)
        const boleto = boletoResult.data?.[0]
        if (boleto) {
          this.dados.obsOutros = ' BOLETO: ' + boleto.TITULO_NOSSONUMERO
        }
      } catch (err) {
        console.log(err)
      }
    },
    montarObservacaoContribuinte() {
      const partes = []
      const textoNfe = this.obterTextoNfeSelecionado()
      const observacaoCliente = String(this.dados.cliente?.OB_OBSERVACOES_REPRESENTACAO || '').trim()
      if (textoNfe) partes.push(textoNfe)
      if (this.dados.id) partes.push(`Pedido: ${this.dados.id}.`)
      if (observacaoCliente) partes.push(observacaoCliente)
      return partes.length ? partes.join('\n').substring(0, 1000) : null
    },
    obterTextoNfeSelecionado() {
      const textoId = this.dados.textoId
      if (!textoId) return ''
      const texto = this.dados.textos.items.find(item => Number(item.ID) === Number(textoId))
      return String(texto?.TEXTO || '').trim()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/movimentos/vendas/components/VendaNotaFiscalModal.vue